import React from 'react';
import { useTranslation } from 'react-i18next';

import { CoveragePetList } from './CoveragePetList';

import styles from './CoveragePetsSection.module.css';

const CoveragePetsNoAction = () => {
  const { t } = useTranslation('petDemos');

  return (
    <div className={styles.policyActionCardPetsSection}>
      <div className={styles.policyActionCardPetsSummary}>
        <div className={styles.policyActionCardPetsSummaryHeader}>
          <h4 className={styles.policyActionCardPetsTotal}>
            {t('policyInformation.petsTotal', { total: 0 })}
          </h4>
        </div>

        <CoveragePetList noPendingAction />
      </div>

      <div className={styles.policyActionCardPetsStatusContainer}>
        <div className={styles.policyActionCardPetsStatusRow}>
          <div className={styles.policyActionCardPetsStatusRowContent}>
            <span className={styles.policyPetsStatusLabel}>
              {t('policyInformation.petsRemovedLabel')}
            </span>

            <span className={styles.policyPetsNotApplicable}>
              {t('policyInformation.notApplicable')}
            </span>
          </div>
        </div>

        <div className={styles.policyActionCardPetsStatusRow}>
          <div className={styles.policyActionCardPetsStatusRowContent}>
            <span className={styles.policyPetsStatusLabel}>
              {t('policyInformation.petsIneligibleLabel')}
            </span>

            <span className={styles.policyPetsNotApplicable}>
              {t('policyInformation.notApplicable')}
            </span>
          </div>
        </div>

        <p className={styles.petsIneligibleDescription}>
          {t('policyInformation.ineligiblePetsNone')}
        </p>
      </div>
    </div>
  );
};

export { CoveragePetsNoAction };
